module.exports = __webpack_public_path__ + "static/Public.com-d22158352860e4c2b9c12c86ee7b354f.jpg";